<template>
  <div class="screen-view-container">
    <div
      v-if="screenConfig"
      v-loading="loading"
      class="screen-view"
      :style="{
        width: screenConfig.panelWidth + 'px',
        height: screenConfig.panelHeight + 'px',
        background: screenConfig.backgroundType === 1 ? screenConfig.background:`url(${screenConfig.background}) no-repeat 100% 100%/100% 100%`,
      }">
      <div
        v-for="(item,index) in screenConfig.chartViews"
        :key="index + 100000"
        :style="{
          width: item.chartWidth + 'px',
          height: item.chartHeight + 'px',
          zIndex: item.sort,
          transform: `translate(${item.chartX+'px'},${item.chartY+'px'})`
        }"
        class="screen-component-item">
        <!-- 各个组件 -->
        <component
          :is="item.chartComponentType"
          :ref="`chartComponent${index}`"
          :config="item"
          :component-type="item.chartComponent"
          :global-config="screenConfig"
          :filter-params="filterParams"
          :is-disabled="item.chartComponentType==='FilterBlock'"
          component-status="view"
          @click.native="handleJump(item)"
          @filterChange="updateComponentData" />
      </div>
    </div>
  </div>
</template>

<script>
import TextBlock from '@/components/charts/text.vue'
import MapChart from '@/components/charts/mapChart.vue'
import PieChart from '@/components/charts/pieChart.vue'
import LineChart from '@/components/charts/lineChart.vue'
import BarChart from '@/components/charts/barChart.vue'
import Number from '@/components/charts/number/number.vue'
import IndependentNumber from '@/components/charts/number/independentNumber.vue'
import Gauge from '@/components/charts/number/gauge.vue'
import ScrollTable from '@/components/charts/table/scrollTable.vue'
import Rank from '@/components/charts/rank.vue'
import RichTextBlock from '@/components/charts/material/showRich.vue'
import BorderBlock from '@/components/charts/material/borderBlock.vue'
import FilterBlock from '@/components/charts/material/filterBlock.vue'
import HeatMapChart from '@/components/charts/heatMap.vue'
import SignName from '@/components/charts/material/signName.vue'
import ImageBlock from '@/components/charts/image.vue'
import { getScreenDataApi } from './fetch'
import { needIndexComponent } from './funcs'
import { defaultFilterDate } from './data'
export default {
  name: 'ScreenView',
  components: {
    TextBlock, // 文本
    MapChart, // 地图
    PieChart, // 饼图
    LineChart, // 折线图
    BarChart, // 垂直柱状图 / 水平柱状图
    Number, // 纯数字
    IndependentNumber, // 独立数字
    Gauge, // 仪表板
    ScrollTable, // 滚动列表
    Rank, // 排行榜
    RichTextBlock, // 富文本编辑
    BorderBlock, // 边框
    FilterBlock, // 筛选框
    HeatMapChart, // 热力图（实际是散点图）
    SignName, // 签名
    ImageBlock,

  },
  data () {
    return {
      screenConfig: null,
      jumpPanelSn: null,
      loading: false,
      jumpDelaySecond: 0,
      timer: null,
      filterParams: {
        startTime: defaultFilterDate.startTime,
        endTime: defaultFilterDate.endTime,
      },
      intervalTimer: null,

    }
  },
  computed: {
    screenId () {
      return this.$route.params.id
    },
  },
  watch: {
    screenId (newVal) {
      if (newVal) {
        this.init()
      }
    },
  },
  created () {
    this.init()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    this.timer = null
    clearInterval(this.intervalTimer)
    this.intervalTimer = null
  },
  mounted () {
    const that = this
    window.addEventListener('popstate', () => {
      clearTimeout(that.timer)
      that.timer = null
    })
    window.addEventListener('pushstate', () => {
      clearTimeout(that.timer)
      that.timer = null
    })
    // 15分钟 定时刷新数据
    this.intervalTimer = setInterval(() => {
      this.updateComponentData()
    }, 15 * 60 * 1000)
  },
  methods: {
    async init () {
      try {
        // this.loading = true
        // 获取大屏数据
        const res = await getScreenDataApi(this.screenId)
        res.chartViews.forEach(item => {
          item.chartSet = JSON.parse(item.chartSet)
          // 如果数据来源是指标库，则请求指标数据
          if ((needIndexComponent(item.chartComponent)) && item.chartSet?.dataSource === 'indicatorLib') {
            const parseData = JSON.parse(item.chartViewData.chartData)
            const chartData = Object.prototype.toString.call(parseData) === '[object Object]' ? parseData : {}
            const initData = JSON.parse(item.chartViewData.initData)
            item.chartViewData = {
              ...item.chartViewData,
              ...chartData,
              initData,
            }
          } else {
            const chartData = JSON.parse(item.chartViewData.chartData)
            const initData = JSON.parse(item.chartViewData.initData)
            item.chartViewData = {
              ...item.chartViewData,
              chartData,
              initData,
            }
          }
          // 兼容独立数字组件和边框组件老数据
          if (item.chartComponentType === 'IndependentNumber' && !item.chartSet.borderStyle?.numberBorderType) {
            item.chartSet.borderStyle.numberBorderType = 1
          }
          if (item.chartComponentType === 'BorderBlock' && !item.chartSet.chartStyle?.borderType) {
            item.chartSet.chartStyle.borderType = 1
          }
        })
        if (res.backgroundType === 1) {
          res.background = res.backgroundColor
        } else {
          res.background = res.backgroundTemplate
        }
        this.jumpPanelSn = res?.jumpPanelSn || null
        this.jumpDelaySecond = res.jumpDelaySecond ? res.jumpDelaySecond * 1000 : null
        this.screenConfig = res
        if (this.jumpDelaySecond && this.jumpPanelSn) {
          this.timer = setTimeout(() => {
            this.$router.push({ path: `/screen/view/${this.jumpPanelSn}` })
          }, this.jumpDelaySecond)
        }
        await this.$nextTick()
        this.updateComponentData(this.filterParams)
      } catch (e) {
        this.$error(e)
      }
    },

    // 获取预览数据
    getPreviewData () {
      if (this.$route.path === '/screen/preview') {
        const LOCAL_PREVIEW_FULL_SCREEN = localStorage.getItem('LOCAL_PREVIEW_FULL_SCREEN')

        if (LOCAL_PREVIEW_FULL_SCREEN) {
          this.screenConfig = JSON.parse(LOCAL_PREVIEW_FULL_SCREEN)
        }
      }
    },

    handleJump (item) {
      if (item.jumpPanelSn) {
        this.$router.push({ path: `/screen/view/${item.jumpPanelSn}` })
      }
    },
    // 调用各个组件的 获取数据方法
    updateComponentData (filterParams) {
      this.filterParams.panelSn = this.$route.params.id
      const keys = filterParams ? Object.keys(filterParams) : []
      if (filterParams) {
        const { startTime, endTime, ...rest } = { ...(this.filterParams ?? {}), ...filterParams }
        this.filterParams = {
          ...rest,
          startTime: startTime || defaultFilterDate.startTime,
          endTime: endTime || defaultFilterDate.endTime,
        }
      }
      // 调用各个组件更新数据方法
      Object.keys(this.$refs).forEach(key => {
        const component = Array.isArray(this.$refs[key]) ? this.$refs[key][0] : {}
        // 如果组件是地图组件，需要更新地图数据
        if (component?.config?.chartComponent === 'mapChart') {
          const { provinceCode, cityCode, regionCode } = this.filterParams
          if (provinceCode || cityCode || regionCode) {
            const mapData = regionCode ? ['100000', provinceCode, cityCode, regionCode] : (cityCode ? ['100000', provinceCode, cityCode] : ['100000', provinceCode])
            component.config.chartSet.chartStyle.map = mapData
          }
        }
        // 更新数据
        if (component?.getChartData && typeof component.getChartData === 'function') {
          component.getChartData(this.filterParams)
        }
        if (component && component.config && component.config.chartComponent === 'filterBlock' && filterParams.addSn && !keys.includes('startTime')) {
          if (component.config.addSn !== filterParams.addSn) {
            component.clearDate()
          }
        }
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.screen-view-container{
  position: relative;
  overflow: auto;
  .screen-view{
    .screen-component-item{
      position: absolute;
      box-sizing: border-box;

    }
  }
}
</style>
